import { useContext, useEffect } from "react";
import useFirestore from "./basic/useFirestore";
import { collection, getDocs, query, where } from "firebase/firestore";
import { FirebaseContext } from "../providers/FirebaseProvider/FirebaseProvider";

function useClubs(ids = undefined, preventCall = false) {
  const { firestoreDb } = useContext(FirebaseContext);

  const firestoreQuery = async () => {
    return ids && ids.length
      ? getDocs(
          query(
            collection(firestoreDb, "societa"),
            where("id", "in", ids ?? []),
          ),
        )
      : getDocs(query(collection(firestoreDb, "societa")));
  };

  const parsingFuntion = (data) => {
    return data.docs.map((doc) => {
      return {
        id: doc.id,
        ...doc.data(),
      };
    });
  };

  const { data, error, isLoading, refreshData } = useFirestore(
    firestoreQuery,
    parsingFuntion,
    preventCall,
  );

  useEffect(() => {
    refreshData();
  }, []);

  return {
    data,
    error,
    isLoading,
    refreshData,
  };
}

export default useClubs;
